import { styled } from '@mui/styles';
import FundOwnershipContext from '../../../context/FundOwnershipContext';

const PREFIX = 'FundOwnership';

export const classes = {
  spreadsheet: `${PREFIX}-spreadsheet`,
  emptyTableSecondaryAction: `${PREFIX}-emptyTableSecondaryAction`,
};

export const StyledFundOwnershipContextProvider = styled(FundOwnershipContext.Provider)(() => ({
  [`& .${classes.spreadsheet}`]: {
    '& td.row-label': {
      minWidth: '380px',
    },
  },

  [`& .${classes.emptyTableSecondaryAction}`]: {
    marginTop: 14,
  },
}));